import Component from '@glimmer/component';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import t from 'ember-intl/helpers/t';
import AlertBanner from 'tio-ui/components/alert-banner';
import { Section } from 'tio-ui/components/layout';
import type { LoanSummary } from 'tio-common/types/loan-summary';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import type { UserExtension as UserModel } from 'tio-data/data/resources/user.ext';
import StrategyFinder0726Form from 'tio-employee/components/strategy-finder-0726/form';

interface S {
  Args: {
    model: {
      loanSummary: LoanSummary;
      user: UserModel;
    };
  };
}

export default class StrategyFinder0726QuestionnaireTemplate extends Component<S> {
  @service declare router: RouterService;

  get hasLoans() {
    return (this.args.model.loanSummary.summaryByLoanType || []).length > 0;
  }

  didSave = (recommendation: RecommendationModel) => {
    this.router.transitionTo('authenticated.strategy-finder-0726.results', recommendation);
  };

  <template>
    <Section>
      <:body>
        <p class="text-sm mb-4">{{t "strategy_finder_0726.subtitle"}}</p>
        {{#if this.hasLoans}}
          <StrategyFinder0726Form
            @user={{@model.user}}
            @loanSummary={{@model.loanSummary}}
            @didSave={{this.didSave}}
            class="md:max-w-3xl"
          />
        {{else}}
          <AlertBanner @intent="warning" data-test-sf-0726-no-loans>
            <p class="text-sm">{{t "strategy_finder_0726.no_loans"}}</p>
          </AlertBanner>
        {{/if}}
      </:body>
    </Section>
  </template>
}
